import { Link } from 'react-router-dom';
import { Container } from '../components/layout/Primitives';

export default function ReturnsInfo() {
  return (
    <Container style={{ padding: 'clamp(3rem,8vw,5rem) 1.5rem', maxWidth: '42rem' }}>
      <h1 className="font-display" style={{ fontSize: 'clamp(2rem, 3vw + 1rem, 3rem)', fontWeight: 300 }}>
        Returns
      </h1>
      <p style={{ lineHeight: 1.75, opacity: 0.78, marginTop: '1.25rem' }}>
        We plan to honour the same thirty-day worn/unwashed policy outlined on the product tabs.
        RMA initiation, prepaid labels and refund timing will execute through your order service once
        the server is plugged in — this route exists so navigation and PDP copy have a canonical
        target today.
      </p>
      <Link to="/contact" style={{ display: 'inline-block', marginTop: '2rem', textDecoration: 'underline' }}>
        Start a return (placeholder — contact team)
      </Link>
      <Link to="/" style={{ display: 'block', marginTop: '1rem' }}>
        ← Home
      </Link>
    </Container>
  );
}
